var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberFourFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberFourFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM13.8166 6.30357C13.3766 6.30357 12.9601 6.49214 12.6694 6.82214L7.47429 12.7637C7.27723 12.9881 7.14905 13.2645 7.10511 13.5599C7.06118 13.8552 7.10335 14.157 7.22658 14.429C7.34981 14.701 7.54887 14.9317 7.79989 15.0934C8.05091 15.2551 8.34324 15.3411 8.64186 15.3409H13.375V16.7143C13.375 16.9748 13.4785 17.2246 13.6627 17.4088C13.8468 17.593 14.0967 17.6964 14.3571 17.6964C14.6176 17.6964 14.8674 17.593 15.0516 17.4088C15.2358 17.2246 15.3393 16.9748 15.3393 16.7143V15.3393H15.9286C16.1891 15.3393 16.4389 15.2358 16.6231 15.0516C16.8072 14.8674 16.9107 14.6176 16.9107 14.3571C16.9107 14.0967 16.8072 13.8468 16.6231 13.6627C16.4389 13.4785 16.1891 13.375 15.9286 13.375H15.3393V7.82629C15.3393 7.42244 15.1789 7.03513 14.8933 6.74956C14.6077 6.464 14.2204 6.30357 13.8166 6.30357ZM13.375 9.00171L9.54857 13.375H13.375V9.00171Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberFourFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberFourFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberFourFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-four-filled') === undefined) {
    customElements.define('cat-icon-number-four-filled', BlocksIconNumberFourFilled);
}
